import React from "react";

const MastersModalBox = ({ children, closeModal }) => {
  return (
    <div className="modal-back">
      <div
        className="partyDetail-modal"
        style={{ height: "90%", width: "85%", backgroundColor: "white" }}
      >
        <div style={{ margin: "15px", overflowY: "auto", height: "85vh" }}>
          <div
            className="closebuttonForMasterModal"
            onClick={() => closeModal("", "")}
          >
            <label className="closebuttonForMasterModal-btn">x</label>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default MastersModalBox;
